module.exports = __webpack_public_path__ + "img/wings.91c44b69.svg";